import { atom } from 'recoil';
import { ReactElement } from 'react';
import { ToastType } from './types';
import { SxProps, Theme } from '@mui/material';

export interface ToastState {
  open: boolean;
  title?: string;
  message?: string | ReactElement;
  type: ToastType;
  sx?: SxProps<Theme>;
}

export const toastAtom = atom<ToastState>({
  key: 'toast',
  default: {
    open: false,
    title: undefined,
    message: undefined,
    type: ToastType.Info
  }
});
